(function () {
// Converts yes/no radio button pairs into toggles
// @codekit-append "../components/02-modules/toggle/_toggle.js";
/**
  Progressively enhances yes/no, on/off, positive/negative radio buttons to
  an iOS-style toggle switch. To use...

  1. Wrap you on/off input/label pairs in a div with a class of `j-toggle`
  2. Ensure that the positive choice radio button is first (source order).
  3. Include CSS style set for `toggle-switch`

  The javascript tracks the on/off state of the control and handles the
  click event. CSS is responsible for the appearance and animation.

*/ (function() {
    var handleToggle = function handleToggle() {
        var el = this, inputs = el.getElementsByTagName("input");
        if (el.getAttribute("data-state") === "on") {
            inputs[0].checked = null;
            inputs[1].checked = "checked";
            inputs[1].click();
            el.setAttribute("data-state", "off");
        } else {
            inputs[0].checked = "checked";
            inputs[1].checked = null;
            inputs[0].click();
            el.setAttribute("data-state", "on");
        }
    };
    var initToggle = function initToggle(t) {
        var inputs = t.getElementsByTagName("input");
        t.className = t.className + " " + "toggle-switch";
        t.addEventListener("click", handleToggle);
        t.setAttribute("data-state", inputs[0].checked ? "on" : "off");
    };
    var toggles = document.getElementsByClassName("j-toggle");
    for(var i = 0; i < toggles.length; i++)initToggle(toggles[i]);
})();


(function() {
    var writeTime = function writeTime() {
        var min, sec, paddedSec;
        if (secondsLeft < 0) secondsLeft = 0;
        min = Math.floor(secondsLeft / 60);
        sec = secondsLeft % 60;
        paddedSec = sec < 10 ? "0" + sec : sec;
        timeEl.innerHTML = min + ":" + paddedSec;
        if (secondsLeft === lowTimeLimit) timeEl.className += " " + lowTimeClass;
    };
    var doTimer = function doTimer() {
        if (secondsLeft < 1) {
            writeTime();
            clearInterval(timer);
            if (form) form.submit();
        } else {
            secondsLeft--;
            writeTime();
        }
    };
    var init = function init() {
        timeEl = document.querySelector("." + timerClass);
        if (timeEl !== null) {
            var secs = timeEl.getAttribute("data-seconds"), formId = timeEl.getAttribute("data-form");
            if (formId) form = document.getElementById(formId);
            if (secs) {
                secondsLeft = parseInt(secs);
                writeTime();
                timer = setInterval(doTimer, 1000);
            }
        }
    };
    var timerClass = "j-timer", lowTimeClass = "time-remaining--danger", lowTimeLimit = 30, timeEl, form, timer, secondsLeft;
    init();
})();


// Scans page for any element with data-datetime attribute and
// replaces the element text with a localized datetime.
// The format of the data-datetime attribute should be yyyyMMddThh:mm:ss.
//
// Example <span data-datetime="20200611T09:00:00">Fallback time to be replaced goes here.</span>
//
(function() {
    var dates = document.querySelectorAll("[data-datetime]");
    var validDateString = /\d{8}T\d{2}:\d{2}:\d{2}/;
    var options = {
        year: "numeric",
        month: "numeric",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
        hour12: true,
        timeZoneName: "short"
    };
    for(var i = 0; i < dates.length; i++){
        var d = dates[i];
        var utc = d.getAttribute("data-datetime");
        if (utc.match(validDateString)) {
            var utcDate = new Date(Date.UTC(parseInt(utc.substr(0, 4)), parseInt(utc.substr(4, 2)) - 1, parseInt(utc.substr(6, 2)), parseInt(utc.substr(9, 2)), parseInt(utc.substr(12, 2)), parseInt(utc.substr(15, 2))));
            d.innerHTML = new Intl.DateTimeFormat("default", options).format(utcDate);
        } else console.log("Element has data-datetime attr, but the format is incorrect: " + utc + ". Expecting yyyyMMddThh:mm:ss");
    }
})();



})();
//# sourceMappingURL=main.js.map
